/**
 * 对话框组件
 * @author wangdi
 */

/*===============================================================================================@

 ## 功能说明

 ### $Dialog.notify
 * param1: string > 显示字符串
 * param2: duration > ms
 * param3: icon > 图标 1、√  2、× 3、★

 @==============================================================================================*/

// 外部依赖
import $wd from '../../utils';

// 添加CSS样式
require("./assets/css/dialog.scss");

let messageNotificationTemplate = require("./assets/views/message-notification.html");

// HTML 模板
let htmlTemplate = {
    createElemByHtml: function (str) {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = str;
        if (tempDiv.childElementCount <= 0) {
            return null;
        } else if (tempDiv.childElementCount == 1) {
            return tempDiv.children[0];
        }
        return tempDiv.children;
    },
    getNotifyElem: function () {
        return this.createElemByHtml(messageNotificationTemplate);
    }
};

let notifyMng = {
    // 配置信息
    top: '45%',
    duration: 2000,
    /**
     * 通知对话框
     * <button class="btn btn-success btn-sm" onclick="$Dialog.notify('我是一个通知！~\(≧▽≦)/~')">点击试下</button>
     *
     * @param {string} str 提示字符串
     * @param {number=} [duration=2000] 持续时间 默认2000ms
     * @param {number=} icon deprecated 提示左侧图标 需要引用字体文件
     * @memberof module:DialogBox
     * @alias module:DialogBox.notify
     * @type {function}
     */
    show: function (str, duration, icon) {
        // 显示元素
        let alertElem = htmlTemplate.getNotifyElem();
        alertElem.querySelector('span').innerHTML = str;
        alertElem.querySelector('i').className = "iconfont icon-duihaoxi";
        alertElem.style.display = "block";
        alertElem.style.top = this.top;
        // 显示位置
        let seat = this.findSeat();
        alertElem.style.marginTop = (50 * seat) + 'px';
        // 持续时间
        let durationTime = duration ? duration : this.duration;
        // 设置左侧图标
        if (typeof icon != 'undefined') {
            switch (icon) {
                case 1:
                case 'success':
                case true:
                    alertElem.querySelector('i').className = "iconfont icon-duihaoxi";
                    break;
                case 2:
                case 'fail':
                case 'error':
                    alertElem.querySelector('i').className = "iconfont icon-error";
                    break;
                case 3:
                case 'star':
                    alertElem.querySelector('i').className = "iconfont icon-shoucang";
                    break;
                default:
                    alertElem.querySelector('i').className = "";
                    break;
            }
        } else {
            alertElem.querySelector('i').className = "";
        }
        document.body.appendChild(alertElem);
        setTimeout(function () {
            alertElem.className = "dialog notify active";
        }, 100);

        let elemToOut = alertElem;
        let obj = this;
        setTimeout(function () {
            elemToOut.className = "dialog notify out";
            obj.leaveSeat(seat);
            setTimeout(function () {
                elemToOut.parentNode.removeChild(elemToOut);
            }, 300);
        }, durationTime);
    },
    // 位置调整
    seatList: function () {
        return [0, 0, 0, 0, 0];
    }(),
    findSeat: function () {
        let largestGap = this.seatList[0] || 0,
            largestGapIndex = 0;
        if (this.seatList.length < 0) return null;
        for (let i = 0; i < this.seatList.length; i++) {
            if (this.seatList[i] < largestGap) {
                largestGap = this.seatList[i];
                largestGapIndex = i;
            }
        }
        this.seatList[largestGapIndex]++;
        return largestGapIndex;
    },
    leaveSeat: function (num) {
        this.seatList[num]--;
    }
};

/**
 * 声音通知
 */
let soundNotify = {
    soundList: {
        '1': {
            src: "http://dove.zol.com.cn/audio/Chime1.ogg"
        },
        '2': {
            src: "http://dove.zol.com.cn/audio/Chime2.ogg"
        },
        '3': {
            src: "http://dove.zol.com.cn/audio/Break.ogg"
        },
        '4': {
            src: "http://dove.zol.com.cn/audio/Sound3.ogg"
        },
        '5': {
            src: "http://dove.zol.com.cn/audio/Buzzer3.ogg"
        },
        '6': {
            src: "http://dove.zol.com.cn/audio/Computer.ogg"
        }
    },
    play: function (soundName) {
        let audioInfo = this.soundList[soundName];
        if (!audioInfo) console.warn("Warning:未找到对应声音文件！");
        if (audioInfo.audioElem) {
            audioInfo.audioElem.pause();
            audioInfo.currentTime = 0;
            audioInfo.audioElem.play();
        } else {
            let audioElem = document.createElement('audio');
            audioElem.src = audioInfo.src;
            audioInfo.audioElem = audioElem;
            document.body.appendChild(audioElem);
            audioInfo.audioElem.pause();
            audioInfo.currentTime = 0;
            audioElem.play();
        }
    }
};

var $message = {
    notify: function (str, duration, icon) {
        notifyMng.show.apply(notifyMng, arguments);
    },
    soundNotify: function () {
        soundNotify.play.apply(soundNotify, arguments);
    }
};

// 接口函数集中调度
$wd.invokeProxy($message, function () {
    return true;
});

export default $message;